import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { emailRegex } from 'scaleflow/utils/regex-match-rules';

export default class EmailInviteModalComponent extends Component {
  @service emailInvite;
  @service store;
  @tracked hasError = false;
  @tracked showConfirmation = false;
  emails = [];
  emailRegex = emailRegex;

  @action
  handleDismissModal() {
    this.emailInvite.toggleInviteModal(false);
  }

  @action
  validateEmails(event) {
    this.emailText = event.target.value;

    const emails = this.emailText.split(',').map((email) => email.trim());
    this.hasError = emails.some(
      (email) => email && !this.emailRegex.test(email),
    );
    this.emails = emails;
  }

  @action
  async handleSend() {
    const promises = [];
    this.emails.forEach((email) => {
      const record = this.store.createRecord('invitation', { email });
      promises.push(record.save().catch((err) => console.debug(err)));
    });
    await Promise.all(promises);
    this.showConfirmation = true;
    this.emailInvite.toggleInviteModal(false);
  }

  @action
  handleAlertClose() {
    this.showConfirmation = false;
  }
}
